import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { PhoneNumberPipe } from '@ecm/material';

import { ContractV7Offer } from '../../../business/api/dashboardV7/contract/contractV7Offer';

@Component({
    selector: 'ecm-tags-infos',
    templateUrl: 'tags-infos.component.html',
    standalone: true,
    imports: [TranslateModule, PhoneNumberPipe],
})
export class TagsInfosComponent {
    @Input()
    public offer!: ContractV7Offer;
}
